import { render, staticRenderFns } from "./MagazineForm.vue?vue&type=template&id=5c99fca8&"
import script from "./MagazineForm.vue?vue&type=script&lang=js&"
export * from "./MagazineForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports